import React from 'react';

import WithLoader from 'components/hoc/WithLoader/WithLoader';

import Button from 'components/shared/Button/Button';

export default WithLoader(Button);
